import { useTranslation } from 'react-i18next';
import { RhfTextField, type RhfTextFieldProps } from './shared/RhfTextField';

export type TaxIdFieldProps = Omit<RhfTextFieldProps, 'label'> & {
  label?: string;
};

/**
 * `TaxIdField` — RHF-bound text input for `Org.legal.taxId`
 * (VAT registration / tax identification number).
 *
 * Just "Tax" in the label, not "VAT/Tax" — matches the agreed
 * cleanup that "VAT" and "Tax" referred to the same field
 * inconsistently across the dashboard.
 */
export function TaxIdField(props: TaxIdFieldProps) {
  const { t } = useTranslation('m-organization');
  return (
    <RhfTextField
      {...props}
      label={props.label ?? t('form.tax_number.title')}
      placeholder={props.placeholder ?? t('form.tax_number.placeholder')}
      helper={props.helper ?? t('form.tax_number.helper')}
      inputMode={props.inputMode ?? 'numeric'}
    />
  );
}
